module.exports = __webpack_public_path__ + "static/media/us.01b0f0cc.svg";